module.exports = __webpack_public_path__ + "img/requirements.f560d833.svg";